var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.value.config.name === "" &&
    _vm.value.config.description === "" &&
    _vm.value.config.value.length < 1
    ? _c("empty", { attrs: { value: _vm.value } })
    : _c("div", { staticClass: "foods_brands" }, [
        _c(
          "div",
          {
            staticClass: "content",
            style: { background: _vm.value.config.bg_color || "#ffffff" },
          },
          [
            _c("div", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.value.config.name)),
            ]),
            _vm.value.config.description
              ? _c("div", { staticClass: "description" }, [
                  _vm._v(" " + _vm._s(_vm.value.config.description) + " "),
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "box" },
              [
                _vm._l(_vm.brandList, function (item) {
                  return _c(
                    "div",
                    { key: item.brand_id, staticClass: "brand" },
                    [
                      _c("el-image", {
                        staticStyle: { width: "100%", height: "100%" },
                        attrs: { fit: "contain", src: item.brand_image },
                      }),
                    ],
                    1
                  )
                }),
                _vm.site_image_open === 1 && _vm.value.config.site_image
                  ? _c(
                      "div",
                      { staticClass: "brand" },
                      [
                        _c("el-image", {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            fit: "contain",
                            src: _vm.value.config.site_image,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }